import React from 'react'
import type { TransformedImageId } from '../../../grab/types'
import { StyleSheet } from '../stylesheet'
import { environment } from '../environment'

// Replicates the same image URL logic as mobile's ChapiImage for sanitized
// images (groups, events, sponsors — prefixed with "z" by the backend).
// Raw MongoDB IDs (infoPratiques) are handled separately since they have
// no prefix and no guaranteed extension.
function resolveImageUrl(imageId: string): string {
  const isSanitized = imageId.startsWith('z')

  if (isSanitized) {
    // Sanitized: "zabc123.jpg" or "zabc123"
    // Same logic as ChapiImage lines 65-75
    const extension = imageId.includes('.') ? '.' + imageId.split('.')[1] : '.jpg'
    const parsedImageId = imageId.replace(extension, '')
    const parsedImageName = `${parsedImageId}_square`
    const parsedImageFile = `${parsedImageName}${extension}`

    if (environment.isBackoffice) {
      // substring(1) strips the "z" prefix → raw MongoDB _square ID
      return `/api/files/${parsedImageName.substring(1)}`
    }
    return `https://${environment.staticSiteUrl}/images/${parsedImageFile}`
  }

  // Raw MongoDB ID (no "z" prefix, no extension) — e.g. infoPratiques
  if (environment.isBackoffice) {
    return `/api/files/${imageId}`
  }
  return `https://${environment.staticSiteUrl}/images/${imageId}`
}

export const ResourceImage: React.FC<{ imageId: TransformedImageId | undefined; alt: string; style?: React.CSSProperties }> = ({
  imageId,
  alt,
  style,
}) => {
  if (!imageId || typeof imageId !== 'string') return null

  const finalUrl = resolveImageUrl(imageId)

  return (
    <div style={{ ...styles.container, ...style }}>
      <img style={{ ...styles.image, objectFit: style?.objectFit ?? 'cover' }} src={finalUrl} alt={alt} />
    </div>
  )
}

const styles = StyleSheet.create({
  container: {
    aspectRatio: 1,
    display: 'flex',
    justifyContent: 'center',
  },

  image: {
    display: 'block',
    height: '100%',
    width: '100%',
    objectFit: 'cover',
  },
})
